import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { Order } from "../../../domain/entities/order/Order";
import { OrderRepositoryImpl } from "../../domain/orderRepositoryImpl/OrderRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const orderRepo = OrderRepositoryImpl.getInstance();

const useViewOrderById = (orderId: string): Order | undefined => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { data } = useQuery(
    {
      queryKey: [`viewOrderById-${orderId}`, auth],
      queryFn: async () => {
        return await orderRepo.getOrderDetails(auth, orderId, apiUrl);
      },
      enabled: Boolean(auth) && Boolean(orderId),
    },
    queryClient,
  );

  return data;
};

export { useViewOrderById };
